import { jsxs as m, jsx as d } from "react/jsx-runtime";
import { forwardRef as O, useRef as L, useState as $, useEffect as M, Fragment as V } from "react";
import f from "./styles.module.less.js";
import { QuestionType as s } from "@law-connect/types";
import { QuestionWrapper as z } from "../question-wrapper/index.js";
import { InputSeparator as G } from "../input-separator/index.js";
import H from "./arrow-right.svg.js";
const J = O(
  (p, x) => {
    var S;
    const {
      title: F,
      form: E,
      onChange: b,
      onSubmit: g,
      onSubmitLabel: R,
      onSubmitDisabled: U = !1,
      disabled: c = !1,
      hideFileUpload: k = !1,
      onFileUpload: A,
      onFileRemove: I,
      files: a,
      language: B,
      hideConditionalQuestions: Q,
      getTranslation: u
    } = p, D = L(a || []), [l, N] = $(E.questions), [w, h] = $(), P = l.filter(
      (e) => {
        var n;
        return e.type === s.File && ((n = e.answer) == null ? void 0 : n.some((r) => !("id" in r)));
      }
    ).length > 0;
    M(() => {
      if (a && a.length !== D.current.length) {
        const e = l.map((n) => n.type === s.File && a ? {
          ...n,
          answer: [
            ...a,
            ...(n.answer || []).filter(
              (r) => !("id" in r) && !a.some((i) => i.name === r.name)
            )
          ]
        } : n);
        N(e);
      }
    }, [a]);
    const C = (e) => {
      if (e && e.type === s.File) {
        const r = l.find((o) => o.id === e.id).answer || [], i = e.answer || [], t = [];
        r.forEach((o) => {
          "id" in o && (i.filter((y) => "id" in y).some((y) => o.id === y.id) || (I && I(o), t.push(o)));
        }), t.length > 0 && (e.answer = [...e.answer || [], ...t]);
      }
      N((n) => {
        const r = n.findIndex((t) => t.id === e.id), i = [...n];
        return i[r] = { ...e }, i;
      }), b && b(l), h("");
    }, v = (e, n) => {
      for (const r of n) {
        if (r.id === e)
          return r;
        if (r.type === s.MultiPart) {
          const i = v(e, r.questions);
          if (i)
            return i;
        }
      }
      return null;
    }, T = () => {
      const e = (n) => n != null && n !== "";
      for (const n of l)
        if (!(n.hideConditionally && Q) && n.required && !e(n.answer)) {
          if (n.onlyAvailableIf) {
            const r = n.onlyAvailableIf, i = v(
              r.questionId,
              l
            );
            if (i && !e(i.answer))
              return h(`${u("toast.answer-question")}: ${n.question}`), !1;
          }
          return h(`${u("toast.answer-question")}: ${n.question}`), !1;
        }
      return !0;
    }, W = (e) => {
      e.preventDefault();
      const n = T();
      if (!c && n) {
        const r = l.filter(
          (i) => i.type !== s.File
        );
        g && g(r);
      }
    }, j = (e) => (n) => {
      if (n.preventDefault(), e.type === s.File && e.answer) {
        const r = e.answer.filter(
          (i) => !("id" in i)
        );
        if (r.length > 0) {
          const i = e.answer.map((t) => ("id" in t || (t.uploading = !0), t));
          C({ ...e, answer: i }), A && A(r);
        }
      }
    };
    return /* @__PURE__ */ m(
      "form",
      {
        ref: x,
        ...p.props,
        className: `${f.overviewForm} ${(S = p.props) == null ? void 0 : S.className}`,
        children: [
          F ? /* @__PURE__ */ d("div", { className: f.overviewFormTitle, children: F }) : null,
          /* @__PURE__ */ m("div", { className: f.overviewQuestions, children: [
            l.map((e) => {
              var n, r;
              if (k && e.type === s.File || Q && e.hideConditionally)
                return null;
              if (e.onlyAvailableIf) {
                const i = e.onlyAvailableIf, t = v(
                  i.questionId,
                  l
                );
                if (t) {
                  if (Array.isArray(i.answer)) {
                    if (!i.answer.includes(
                      t.answer
                    ))
                      return null;
                  } else if (t.answer !== (i == null ? void 0 : i.answer))
                    return null;
                }
              }
              return /* @__PURE__ */ m(V, { children: [
                /* @__PURE__ */ d(
                  z,
                  {
                    questions: l,
                    question: e,
                    onChange: C,
                    disabled: c,
                    language: B,
                    getTranslation: u
                  }
                ),
                e.type === s.File && /* @__PURE__ */ d(
                  "button",
                  {
                    className: f.uploadButton,
                    onClick: j(e),
                    disabled: c || !((n = e.answer) != null && n.filter((i) => !("id" in i)).length) || ((r = e.answer) == null ? void 0 : r.filter(
                      (i) => !("id" in i) && i.uploading
                    ).length) > 0,
                    children: u("prematter.upload")
                  }
                ),
                /* @__PURE__ */ d(G, {})
              ] }, e.id);
            }),
            w ? /* @__PURE__ */ d("div", { className: f.overviewFormError, children: w }) : null
          ] }),
          /* @__PURE__ */ m(
            "button",
            {
              className: f.submitButton,
              type: "submit",
              onClick: W,
              disabled: !!w || c || P || U,
              children: [
                R || u("chat.submit"),
                /* @__PURE__ */ d(H, {})
              ]
            }
          )
        ]
      }
    );
  }
);
J.displayName = "OverviewForm";
export {
  J as OverviewForm
};
